import React, { useCallback } from 'react';
import {
  visitorActions,
  visitorFilterActions,
  visitorPageActions,
  visitorSelectors,
  filters,
} from '../';
import { useDispatch, useSelector } from 'react-redux';
import { detailOpenState, getCurrentPage } from 'reducers/ui';
import { getUserAssignedDepartmentList } from 'reducers/users';
import useFilters from 'containers/Base/useFilters.js';
import LayoutWithMap from 'containers/Base/LayoutWithMap.jsx';
import PropTypes from 'prop-types';
import { VISITOR_DEFAULT_FILTERS } from '../Modules/filters';

const Visitors = ({
  columns,
  filtersRequired,
  details,
  loading,
  downloadable,
}) => {
  //---------------------------Selectors---------------------------
  const pageUrl = useSelector(state => getCurrentPage(state));
  const detailOpen = useSelector(state => detailOpenState(state));
  const visitorListData = useSelector(state =>
    visitorSelectors.getVisitorListTransformed(state),
  );
  const totalEntries = useSelector(state =>
    visitorSelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state => visitorSelectors.getFilters(state));
  const forceRefresh = useSelector(state =>
    visitorSelectors.getForceRefresh(state),
  );
  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchVisitorsList = useCallback(
    ({ filters, from }) =>
      dispatch(visitorActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  const dispatchPrintVisitorsList = useCallback(
    ({ filters, from }) =>
      dispatch(visitorPageActions.printVisitorList({ filters, from })),
    [dispatch],
  );
  const onDownloadClick = () => {
    dispatchPrintVisitorsList({ filters: localFilterValues });
  };
  const fetchVisitors = from => {
    dispatchFetchVisitorsList({
      filters: localFilterValues,
      from,
    });
  };
  const onUpdate = filters => {
    dispatchFetchVisitorsList({ filters });
  };
  return (
    <LayoutWithMap
      header="Visitors"
      cols={columns}
      data={visitorListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //details
      DetailComponent={details}
      //creating and editing
      editable={false}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={filters({
        site: localFilterValues.site,
        userAssignedDepartments,
      })}
      linkedFilterFields={{ site: ['visitor', 'purpose', 'destination'] }} // clear the fields in array if site changes
      forceOpenDetailPanel={detailOpen[pageUrl]}
      downloadable={downloadable}
      onDownloadClick={onDownloadClick}
      defaultFilterValues={VISITOR_DEFAULT_FILTERS}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            visitorFilterActions.setFilterKey({ key: true });
            visitorFilterActions.setFilters({ filters });
          },
        })
      }
      //end-filters
      onUpdate={onUpdate}
      fetchData={fetchVisitors}
    />
  );
};
Visitors.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
  userAssignedDepartments: PropTypes.array,
  downloadable: PropTypes.bool,
};

export default Visitors;
